<template>
    <div class="Settle">
        <div class="left">
           <div class="logo">
               <img src=""/>
           </div>
           <div class="text">
               <p>商家账号注册</p>
               <p>信服到家</p>
           </div>
           <p class="login">
              已有账号？
              <span class="link"  @click="$router.push('/login')">去登录</span>
              <!-- <el-link class="link" type="danger">去登录</el-link> -->
           </p>
        </div>
        <div class="right">
            <div class="steps">
              <p><span><i class="el-icon-check"></i></span>填写账号信息</p><span class="lin"></span>
              <p><span><i class="el-icon-check"></i></span>填写企业信息</p><span class="lin"></span>
              <p><span class="in">3</span>审核</p>
            </div>    
            <div class="main">
                <div class="title">审核</div>
                <div class="succeed">
                <i class="el-icon-circle-check" style="text-align:center"></i>
                <span class="reg" >注册成功</span>
                <span class="regok">注册成功，请等待审核。</span>
                <span class="go" @click="$router.push('/');">去首页</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    data() {
       return {
         
       }
    },
    methods: {
      submitForm() {
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleChange1(file, fileList) {
        // var formdata=new FormData();
        // formdata.append("formdata",file);
        this.ruleForm.zhuFile = fileList.slice(-1)
        // this.uploadFile(formdata).then(res=>{
        //     if(res.code==1){
        //           this[imgId]=res.data.formdata[0];
        //           this[inImg] = fileList.slice(-1);
        //     }else{
        //         this.$message({
        //             type:"warning",
        //             message:res.msg
        //         })
        //     }
        // })
      },
      handleRemove(file, fileList) {
        //console.log(file, fileList);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
    }

  }
</script>
<style  lang='scss' scoped>
::v-deep .el-input-group__append{
	background: #fff;
}
.agreement ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    border-color: #e72f0d;
    background: #E72F0D
}


.Settle{
  width:100%;
  display: flex;
  background: #F7F8FA;
  height: 100%;
}
.text p:first-child{
  font-size: 16px;
  color:#333333;
  width: 100%;
  text-align: center;
}
.text p:last-child{
  font-size: 12px;
  color:#999999;
  width: 100%;
  text-align: center;
  margin-top: 9px;
  margin-bottom: 43px;
}
.logo{
    margin: 24px auto;
    width:42px;
    height: 42px;
    background: #ccc;
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: 18px;
}
.login{
    font-size:16px;
    color: #333333;
    width: 100%;
    text-align: center;
}
.login .link{
    color: #E72F0D;
    font-size:16px;
    cursor: pointer;
}
.left{
  width:13.7%;
  background: #fff;
}
.right{
 width:86.3%;
}
.steps{
 height: 84px;
 display: flex;
 align-items: center;
 padding-left: 23%;
 box-sizing: border-box;
 background: #fff;
}
.steps p span.in{
  background: #E72F0D;
}
.steps p span{
   background: #CCCCCC;
   display: block;
   border-radius: 50%;
   overflow: hidden;
   font-size: 18px;
   color: #fff;
   text-align: center;
   width:36px;
   height: 36px;
   line-height: 36px;
   margin-right: 12px;
}
.steps .lin{
    display: block;
    width:14%;
    background: #E6E9ED;
    height: 3px;
    margin:0 12px;
}
.steps p{
    display: flex;
    align-items: center;
}
.steps p span i{
    font-size: 28px;
    line-height: 36px;
}

 ::v-deep .el-date-editor .el-range-separator {
    padding: 0;
  }
.succeed span{
text-align:center;display: block;
    width: 100%;
}
 .el-icon-circle-check::before{color:#13A02B;font-size: 32px;display:block}
  .main {
    background: #fff;
    margin: 25px;
  }

  .from {
    width: 60%;
    margin: 0 auto;
    margin-top: 64px;
  }

  .main .title {
    color: #333333;
    padding: 22px;
    padding-left: 24px;
    border-bottom: 1px solid #D7DBE0;

  }

  .main {
        min-height:600px;
  }
  .succeed{
    margin:64px auto 0 auto;
    width:35%;
    display:flex;
    justify-content:center;
    flex-direction:column;
  }
  .Settle {
    width: 100%;
    display: flex;
    background: #F7F8FA;
    height: 100%;
  }
  .reg{
    width: 72px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 30px;
    display: block;
  }
  .regok{
    width: 176px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 25px;
  }
  .go{
    margin: 0 auto;
    width: 186px!important;
    margin-top:30px;
    background: #E72F0D;
    border-radius: 3px;
    text-align:center;
    line-height:42px;
    display:block;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    cursor: pointer;
  }
  .right {
    width: 86.3%;
  }
</style>
